import { AppVersion } from '../meta/app-version'
import { Copyright } from '../meta/copyright'

export function Footer(): JSX.Element {
  return (
    <footer className='p-4 h-[74px] flex flex-col justify-end items-end'>
      <Copyright className='font-medium text-gray-600' />

      <AppVersion commitsDirection='row' />
    </footer>
  )
}
